import { cn } from "~/lib/utils";

const WORKFLOW_STEP_COLORS = [
  "text-chart-1",
  "text-chart-2",
  "text-chart-3",
  "text-chart-4",
  "text-chart-5",
];

// Sets currentColor; a workflow with more steps than colours starts over
export const workflowStepColor = (order: number) =>
  WORKFLOW_STEP_COLORS[order % WORKFLOW_STEP_COLORS.length];

export const WorkflowStepSwatch = ({ order }: { order: number }) => (
  <span
    className={cn(
      "h-2.5 w-4 shrink-0 rounded-xs bg-current",
      workflowStepColor(order),
    )}
  />
);
